import React from "react";
import { CashReceiptsFormViewForExtend } from "./CashReceiptsFormView";
import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { DocumentTypeCode } from "@odata/GeneratedEnums";

export class CashReceiptsReceivedFormView extends CashReceiptsFormViewForExtend {
    documentTypeCode = DocumentTypeCode.CashReceiptReceived;
}

export default withPermissionContext(CashReceiptsReceivedFormView);